import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { PasswordResetWrapper } from 'components/user/PasswordReset';
import { handleFieldError } from 'libs/api/errorHandle';
import { passwordUpdate } from 'libs/api/user';
import { showNotification } from 'libs/utils';
import { TPasswordUpdate } from 'modules/user';
import { Button, Form, Input, Typography } from 'antd';
import { FormWrapper } from 'GlobalStyles';

const { Title } = Typography;
const PasswordUpdate = () => {
  const [form] = Form.useForm();
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const { uidb64 = '', token = '' } = useParams();
  const handleSubmit = async (value: TPasswordUpdate) => {
    try {
      setSubmitButtonDisabled(true);
      await passwordUpdate(uidb64, token, { password_new: value.password_new });
      showNotification('success', '비밀번호가 변경되었습니다.');
    } catch (e) {
      handleFieldError(e, form);
      throw e;
    } finally {
      setSubmitButtonDisabled(false);
    }
  };
  const onClickSubmit = () => {
    form.validateFields().then((value) => {
      handleSubmit(value as TPasswordUpdate);
    });
  };

  return (
    <PasswordResetWrapper style={{ paddingTop: '30px' }}>
      <Title level={2}>새로운 비밀번호를 입력해주세요</Title>
      <FormWrapper style={{ maxWidth: '300px', paddingTop: '10px', paddingBottom: '10px' }}>
        <Form form={form} name='password_update' className='form-inline' layout='vertical'>
          <Form.Item
            name={'password_new'}
            label='새로운 비밀번호'
            className='form-item'
            rules={[
              { required: true },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (value && value.length >= 8) {
                    return Promise.resolve();
                  }
                  return Promise.reject('비밀번호는 8자리 이상이어야 합니다.');
                },
              }),
            ]}
          >
            <Input.Password size='large' type='password' placeholder='새로운 비밀번호를 입력해주세요' />
          </Form.Item>
          <Form.Item
            name={'password_check'}
            label='새로운 비밀번호'
            className='form-item'
            dependencies={['password_new']}
            hasFeedback
            rules={[
              {
                required: true,
                message: '패스워드를 입력해주세요',
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue('password_new') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject('패스워드가 일치하지 않습니다.');
                },
              }),
            ]}
          >
            <Input.Password size='large' type='password' placeholder='비밀번호를 한번 더 입력해주세요.' />
          </Form.Item>
          <Form.Item shouldUpdate={true} className='form-button'>
            {() => (
              <Button
                type='primary'
                htmlType='submit'
                size='large'
                onClick={onClickSubmit}
                loading={submitButtonDisabled}
              >
                저장
              </Button>
            )}
          </Form.Item>
        </Form>
      </FormWrapper>
    </PasswordResetWrapper>
  );
};

export default PasswordUpdate;
